/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-len */
import { motion, useSpring, useTransform, AnimatePresence } from 'framer-motion';
import React, { useCallback, useRef, useState } from 'react';
import { useInViewScroll, useScrolledTheme, useWindowSize, useSanitizedTranslation } from '../../hooks';
import { makeVariants } from '../../utils/makeVariants';
import { SplitH1, XumoButton as Button, SplitH4, MotionImage, StackedContent } from 'ui';
import Link from 'next/link';
import Image from 'next/image';

import { CTA, Colors, IImage } from '../../types';
import { useRouter } from 'next/router';

export type JointVenture = {
  img: string;
  alt: string;
};

export type BgImgHeroProps = {
  content: any;
  bgImg: string;
  jointVenture?: JointVenture;
};


export const BgImgHero = ({bgImg, jointVenture, content}: BgImgHeroProps) => {
  const { t } = useSanitizedTranslation();
  const { ref, progress: amt } = useInViewScroll([0, 1], ['start 100px', 'end 0vh']);
  const scrollY = useTransform(amt, [0, 1], [0, 350]);

  const [heroLoaded, setLoaded] = useState(false);
  const imageLoaded = () => setLoaded(true);
  const fadeInProps = {
    onLoadingComplete: imageLoaded,
    initial: { opacity: 0 },
    animate: { opacity: heroLoaded ? 1 : 0 },
  };

  console.log(jointVenture)

  return (
    <motion.section className="relative z-40 flex w-full justify-center bg-white" data-testid={'text-section'}>
      <div className="px-10 pt-8 pb-10 lg:pb-16">
        <div className={`relative flex overflow-hidden rounded-t-2xl lg:rounded-3xl bg-xumoBlack p-16 aspect-video lg:aspect-auto lg:min-h-[80vh]`}>
          <div 
            className="absolute left-0 top-0 h-[calc(100%+100px)] w-full" 
          >
            <MotionImage
              style={{ y: scrollY }}
              src={bgImg}
              alt="background image"
              fill
              priority
              {...fadeInProps}
              className="-top-8 object-cover brightness-90"
              sizes="100vw"
            />
          </div>

          <div 
            style={{
              background: 'linear-gradient(94deg, rgba(71, 37, 62, 0.80) 28.72%, rgba(255, 255, 255, 0.00) 100%)',
              backgroundBlendMode: 'multiply'
            }}
            className="absolute left-0 top-0 h-full w-full hidden lg:block" 
          />
          <div className="z-10 relative w-2/3 2xl:w-1/2 hidden lg:block">
             <StackedContent
                fullalways
                fullheight
                space
                noMargin
                light
                content={content}
              />
          </div>
        </div>
        <div className="bg-xumoBerryAltGradient p-10 rounded-b-2xl w-full block lg:hidden">
            <StackedContent
              fullalways
              fullheight
              space
              noMargin
              light
              center
              content={content}
            />
        </div>
        {jointVenture &&
              <div className="flex items-center justify-center mt-3 bg-[#EFF3F5] rounded-2xl p-7 gap-6 flex-wrap">
                  <span data-i18n className="inline-block text-left text-base weight-400 text-black">
                      {t("A joint venture between")}
                  </span>
                  <Image src={jointVenture.img} alt={jointVenture.alt} width={200} height={75} className="object-contain" />
              </div>
          }
      </div>
    </motion.section>
  );
};
